import {
    getAccessTier,
    getSubscriptionLabel,
    isPremiumStatus,
    isVenueStatus
} from './subscriptionStatus';

const CAPABILITIES = {
    Free: {
        tier: 'Free',
        isPaid: false,
        isPremium: false,
        isVenue: false,
        canUseMarketplace: true,
        canReadContent: true,
        canBrowseVenues: true,
        canAccessAdvancedAnalytics: false,
        canCreateUnlimitedEvents: false,
        canAccessPremiumPerks: false,
        canManageVenueProduct: false,
        memberSummary: 'Free plan with discovery, marketplace access, and core scoring.',
        upgradePrompt: 'Upgrade for unlimited events, richer analytics, and extra member benefits.'
    },
    Premium: {
        tier: 'Premium',
        isPaid: true,
        isPremium: true,
        isVenue: false,
        canUseMarketplace: true,
        canReadContent: true,
        canBrowseVenues: true,
        canAccessAdvancedAnalytics: true,
        canCreateUnlimitedEvents: true,
        canAccessPremiumPerks: true,
        canManageVenueProduct: false,
        memberSummary: 'Premium member with unlimited tracking, deeper analytics, and extra perks.',
        upgradePrompt: null
    },
    Venue: {
        tier: 'Venue',
        isPaid: true,
        isPremium: false,
        isVenue: true,
        canUseMarketplace: true,
        canReadContent: true,
        canBrowseVenues: true,
        canAccessAdvancedAnalytics: false,
        canCreateUnlimitedEvents: false,
        canAccessPremiumPerks: true,
        canManageVenueProduct: true,
        memberSummary: 'Venue account with operational tools for club teams, members, events, and offers.',
        upgradePrompt: null
    }
};

export const getMembershipCapabilities = (subscriptionOrStatus) => {
    const normalized = getSubscriptionLabel(subscriptionOrStatus);
    const accessTier = getAccessTier(subscriptionOrStatus);

    if (accessTier === 'Venue' || normalized === 'Venue' || isVenueStatus(subscriptionOrStatus)) {
        return CAPABILITIES.Venue;
    }

    if (accessTier === 'Premium' || normalized === 'Premium' || isPremiumStatus(subscriptionOrStatus)) {
        return CAPABILITIES.Premium;
    }

    return CAPABILITIES.Free;
};
